import { BaseApiService } from '@/shared/api/BaseApiService';

export interface ClinicProfileData {
  id: string;
  organizationId: string;
  clinicId: string;
  clinicName: string;
  brandLogoUrl: string | null;
  displayName: string;
  phone: string | null;
  email: string | null;
  website: string | null;
  gstNumber: string | null;
  registrationNumber: string | null;
  defaultCountryId: string | null;
  defaultStateId: string | null;
  defaultDistrictId: string | null;
  timezone: string;
  allowOverbooking: boolean;
  defaultApptDurationMin: number;
  defaultBufferBeforeMin: number;
  defaultBufferAfterMin: number;
  slotGranularityMin: number;
  address: {
    id: string;
    countryId: string;
    stateId: string;
    districtId: string | null;
    line1: string;
    line2: string | null;
    cityTown: string;
    pincode: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateClinicProfileInput {
  clinicName?: string;
  brandLogoUrl?: string | null;
  timezone?: string;
  allowOverbooking?: boolean;
  defaultApptDurationMin?: number;
  defaultBufferBeforeMin?: number;
  defaultBufferAfterMin?: number;
  slotGranularityMin?: number;
}

export class ClinicProfileService extends BaseApiService {
  protected readonly resourcePath = 'settings';

  async getProfile(): Promise<ClinicProfileData> {
    return this.get('');
  }

  async updateProfile(input: UpdateClinicProfileInput): Promise<ClinicProfileData> {
    return this.put('', input);
  }
}
